import { jsx } from 'react/jsx-runtime';
import { EGDSIcon } from '@egds/react-core/icons';
import { classNames } from '@egds/react-core/utils';
import { EGDSIconLoyaltyThemes } from '../types/index.esm.js';
import styles from '../../../../../styles/egds-lodging-icon-loyalty-themes.css';

const getClassNameList = classNames.bind(styles);
const IconLoyaltyThemes = (props) => {
    const { className, description, getMarkerPopup, id, name, shadow, spotlight, size, theme, title } = props;
    const iconLoyaltyClassname = getClassNameList(`uitk-icon-loyalty-${theme}`, className);
    const isLoyaltyTheme = theme &&
        theme ===
            (EGDSIconLoyaltyThemes.LOW ||
                EGDSIconLoyaltyThemes.HIGH ||
                EGDSIconLoyaltyThemes.MID ||
                EGDSIconLoyaltyThemes.EXTRAHIGH);
    return (jsx(EGDSIcon, { className: iconLoyaltyClassname, description: description, getMarkerPopup: getMarkerPopup, id: id, name: name, shadow: shadow, spotlight: spotlight, size: size, theme: isLoyaltyTheme ? 'default' : theme, title: title }));
};
IconLoyaltyThemes.displayName = 'IconLoyaltyThemes';

export { IconLoyaltyThemes };
//# sourceMappingURL=index.esm.js.map
